import { createLogger, mapActions, mapGetters, mapMutations } from "vuex";
import { VueSlideToggle } from "vue-slide-toggle";

export default {
    name: "category-select",
    data() {
        return {
            showAll: true,
            isOpen: true,
            selectedFilters: [],
            limit: 5,
        };
    },
    props: {
        price: {
            type: Array,
            default: () => [],
        },
        label: {
            type: String,
            default: "",
        },
        list: {
            type: Array,
            default: () => [],
        },
        slug: {
            type: String,
            default: "",
        },
        name: {
            type: String,
            default: "",
        },
        isLink: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        VueSlideToggle,
    },
    watch: {},
    created() {
        if (this.$route.params.filterSlug) {
            const element = this.list.find(item => item.slug === this.$route.params.filterSlug);
            if (element) {
                this.selectedFilters.push({
                    slug: this.slug,
                    itemSlug: element.slug,
                });
            }
        }
        if (Object.keys(this.$route.query).length) {
            Object.keys(this.$route.query).map(key => {
                this.$route.query[key].split(",").map(filterElement => {
                    this.selectedFilters.push({
                        slug: key,
                        itemSlug: filterElement,
                    });
                });
            });
        }
    },
    mounted() {},
    computed: {
        ...mapGetters({
            filterCategories: "setting/filterCategories",
            robots: "system/robots",
        }),
    },
    methods: {
        ...mapMutations({}),
        ...mapActions({
            fetchList: `category/GET_FILTER_PRODUCTS_LIST`,
        }),
        generateFilterLink(filterOption) {
            const { params, query, name } = this.$route;
            const routeQuery = { ...query };
            const hasFilterSlug = params.filterSlug;

            if (hasFilterSlug && params.filterSlug === filterOption.slug) {
                const { filterSlug, ...otherParams } = params;
                return {
                    name,
                    params: { ...otherParams },
                    query: { ...query },
                };
            } else {
                if (this.checkSlug(routeQuery, filterOption)) {
                    return {
                        name,
                        params,
                        query: routeQuery,
                    };
                }

                if (!hasFilterSlug) {
                    return {
                        name,
                        params: {
                            ...params,
                            filterSlug: filterOption.slug,
                        },
                        query: { ...query },
                    };
                } else {
                    routeQuery[this.slug] = filterOption.slug;
                    return {
                        name,
                        params: { ...params },
                        query: routeQuery,
                    };
                }
            }
        },
        checkSlug(routeQuery, filterOption) {
            if (Object.keys(routeQuery).length && routeQuery[this.slug]) {
                let existingSlugs = routeQuery[this.slug].split(",");
                const slugIndex = existingSlugs.indexOf(filterOption.slug);
                switch (slugIndex) {
                    case -1:
                        existingSlugs.push(filterOption.slug);
                        break;
                    default:
                        existingSlugs.splice(slugIndex, 1);
                        break;
                }
                if (existingSlugs.length === 0) {
                    delete routeQuery[this.slug];
                } else {
                    routeQuery[this.slug] = existingSlugs.join(",");
                }
                return true;
            }
            return false;
        },
        filter(item) {
            const index = this.selectedFilters.findIndex(filter => filter.itemSlug === item.slug);
            if (index > -1) {
                this.selectedFilters.splice(index, 1);
            } else {
                this.selectedFilters.push({
                    slug: this.slug,
                    itemSlug: item.slug,
                });
            }
            this.$emit("updateHandler");
        },
    },
};
